import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileDataObjectTransferService {
  private subject = new Subject<any>();
  private FileDataObjectTransferServiceMessage = new BehaviorSubject({});
  currentApprovalStageMessage = this.FileDataObjectTransferServiceMessage.asObservable();
  constructor() {

  }
  sendMessage(message: string) {
    this.subject.next({ text: message });
  }

  updateApprovalMessage(message: any) {
    this.FileDataObjectTransferServiceMessage.next(message)
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}